import React from 'react';
import ClientAnimalsModule from './ClientAnimalsModule';

/**
 * Alias de rută: același flux ca /animals (clientDashboardService + ClientAnimalsModule).
 */
const MyPets: React.FC = () => {
  return <ClientAnimalsModule />;
};

export default MyPets;
